const questions = [
  {
    id: 1,
    title: "How Can I buy an ape ?",
    info: "Ape purchasing happens through our ‘Apeintosh’ which can be found at the top of the website. When minting commences, login to the computer with the ‘super secret’ password, connect your wallet and click on ‘mint.exe’. Follow the prompted procedures and BOOM! You’re a fully fledged degenerate ape.",
  },
  {
    id: 2,
    title:
      "Are there other benefits for being a Solana Banana NFT holder? (Pairing)",
    info: "If you pair a Solana Banana NFT in the same wallet as a Degen Ape or an SMB, you will automatically qualify for our monthly airdrop. If you stack Solana Banana NFTs with an Ape or a Monke in your wallet, you will increase your odds of winning.This monthly Airdrop will be a mix of Solana NFT based rewards, which will both be fruitful, and will help promote new NFTs entering the Solana ecosystem. We like to call this mechanic.... 'A Banana Bomb'.",
  },
  {
    id: 3,
    title: "What is the total supply?",
    info: "There will be 1,500 Solana Bananas minted from over 90 attributes - every Banana will be unique. 100 Bananas are being kept for promotional purposes. There will never be more than 1,500 Solana Bananas.",
  },
  {
    id: 4,
    title: "Whose birth number can I use?",
    info: "Edison bulb direct trade gentrify beard lo-fi seitan sustainable roof party franzen occupy squid. Knausgaard cronut succulents, scenester readymade shabby chic lyft. Copper mug meh vegan gentrify.",
  },
  {
    id: 5,
    title: "When do I recieve a password ordered by letter?",
    info: "Locavore franzen fashion axe live-edge neutra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwave blog, microdosing thundercats migas vaporware viral lo-fi seitan ",
  },
];
export default questions
